/* MCR product card: image scrub with mini dots on hover (desktop pointer devices only).
   Markup: .mcr-card__media[data-mcr-card-images="url|url|..."] > img.mcr-card__img--primary (+ --secondary) + .mcr-card__dots
   Images beyond the first two are only requested on first hover. */
(function () {
  'use strict';
  if (window.__mcrCardInit) return;
  window.__mcrCardInit = true;

  /* Multi-variant 'Add to bag': the button lives in a real /cart/add form (works without JS);
     with JS it opens Dawn's quick-add modal (size picker) instead of submitting. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mcr-open-quick-add]');
    if (!btn) return;
    var opener = btn.closest('modal-opener');
    var modal = opener && document.querySelector(opener.getAttribute('data-modal'));
    if (modal && typeof modal.show === 'function') e.preventDefault();
  });

  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function setup(media) {
    if (media.__mcr) return media.__mcr;
    var urls = (media.getAttribute('data-mcr-card-images') || '').split('|').filter(Boolean);
    var hasSecondary = media.getAttribute('data-mcr-has-secondary') === 'true';
    var dots = media.querySelectorAll('.mcr-card__dot');
    var state = { urls: urls, hasSecondary: hasSecondary, dots: dots, idx: -1, scrub: null, raf: 0, x: 0 };
    media.__mcr = state;
    return state;
  }

  function show(media, st, idx) {
    if (idx === st.idx) return;
    st.idx = idx;
    for (var i = 0; i < st.dots.length; i++) st.dots[i].classList.toggle('is-active', i === idx);
    if (idx === 0) return media.setAttribute('data-mcr-mode', 'primary');
    if (idx === 1 && st.hasSecondary) return media.setAttribute('data-mcr-mode', 'secondary');
    if (!st.scrub) {
      st.scrub = document.createElement('img');
      st.scrub.className = 'mcr-card__img mcr-card__scrub';
      st.scrub.alt = '';
      st.scrub.setAttribute('aria-hidden', 'true');
      st.scrub.decoding = 'async';
      var first = media.querySelector('img');
      if (first) {
        st.scrub.width = first.width;
        st.scrub.height = first.height;
      }
      media.insertBefore(st.scrub, media.querySelector('.mcr-card__dots'));
    }
    if (st.urls[idx] && st.scrub.getAttribute('src') !== st.urls[idx]) st.scrub.src = st.urls[idx];
    media.setAttribute('data-mcr-mode', 'scrub');
  }

  function reset(media, st) {
    if (st.idx === -1) return;
    st.idx = -1;
    media.removeAttribute('data-mcr-mode');
    for (var i = 0; i < st.dots.length; i++) st.dots[i].classList.toggle('is-active', i === 0);
  }

  document.addEventListener(
    'mousemove',
    function (e) {
      var card = e.target.closest && e.target.closest('.mcr-card');
      var media = card && card.querySelector('.mcr-card__media[data-mcr-card-images]');
      if (!media) return;
      var st = setup(media);
      if (st.urls.length < 2) return;
      st.x = e.clientX;
      st.y = e.clientY;
      if (st.raf) return;
      st.raf = requestAnimationFrame(function () {
        st.raf = 0;
        var r = media.getBoundingClientRect();
        if (st.y < r.top || st.y > r.bottom || st.x < r.left || st.x > r.right) return reset(media, st);
        var idx = Math.min(st.urls.length - 1, Math.max(0, Math.floor(((st.x - r.left) / r.width) * st.urls.length)));
        show(media, st, idx);
      });
    },
    { passive: true }
  );

  document.addEventListener(
    'mouseout',
    function (e) {
      var card = e.target.closest && e.target.closest('.mcr-card');
      if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
      var media = card.querySelector('.mcr-card__media[data-mcr-card-images]');
      if (media && media.__mcr) reset(media, media.__mcr);
    },
    { passive: true }
  );
})();
